import { useEffect, useState } from 'react';
import axios from 'axios';
import LightAdmin from 'components/headers/lightAdmin';
import AnimationRevealPage from 'helpers/AnimationRevealPage';
import Footer from "components/footers/Footer.jsx";
import Swal from 'sweetalert2';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

const OrderSalesAdmin = () => {
    const { t } = useTranslation();
    const [orders, setOrders] = useState([]);
    const [isSuperAdmin, setIsSuperAdmin] = useState(false);
    const [loading, setLoading] = useState(false);
    const [searchOrderID, setSearchOrderID] = useState('');
    const [selectedDate, setSelectedDate] = useState('Tout le temps'); // default "all time"
    const navigate = useNavigate();

    useEffect(() => {
        const role = localStorage.getItem('role'); 
        const adminType = localStorage.getItem('admin_type'); 
        setIsSuperAdmin(role === 'admin' && adminType === 'super');
    }, []);

    useEffect(() => {
        if (isSuperAdmin) fetchOrders();
    }, [isSuperAdmin]);
const fetchOrders = async () => {
        setLoading(true);
        const token = localStorage.getItem('authToken');
        if (!token) {
            setLoading(false);
            return;
        }

        let allOrders = []; // <-- FIX: Initialize allOrders here

        try {
            const ordersResp = await axios.get('https://rehabwmg.online/api/admin/orders', {
                headers: { Authorization: `Bearer ${token}` }
            });
            
            // Re-assign allOrders with data from the response
            allOrders = ordersResp.data.data || ordersResp.data;

            // Only delivered orders
            allOrders = allOrders.filter(order => order.Status === 'livré');

            const ordersWithTotals = allOrders.map(order => {
                const totalQuantity = order.order_items.reduce((sum, item) => sum + item.Quantity, 0); // <-- FIX: totalQuantity is defined here

                const totalProfit = order.order_items.reduce((sum, item) => {
                    const profitPerItem = parseFloat(item.product?.profitPrice || 0);
                    const quantity = item.Quantity || 0;
                    return sum + profitPerItem * quantity;
                }, 0);

                // --- Profit Admin Calculation Corrected (Handles 15 DH per unit after the 1st unit) ---
                let profitAdmin = 0;
                
                // Track the total number of units processed so far across the entire order
                let unitsProcessed = 0; 
                
                order.order_items.forEach((item) => {
                    const profitPerUnit = parseFloat(item.product?.profitPrice || 0);
                    const quantity = item.Quantity || 0;
                    
                    // Iterate through each unit of the current product line
                    for (let i = 0; i < quantity; i++) {
                        unitsProcessed++;
                        
                        // Every unit gets the base profit
                        let unitProfitAdmin = profitPerUnit;
                        
                        // Only add the 15 DH fee if this unit is *not* the first unit in the entire order (unitsProcessed > 1)
                        if (unitsProcessed > 1) {
                            unitProfitAdmin += 15;
                        }
                        
                        profitAdmin += unitProfitAdmin;
                    }
                });
                // --------------------------------------------------------------------------------------

                const productsList = order.order_items
                    .map(item => item.product?.Name?.fr || item.Name)
                    .join(', ');

                return {
                    ...order,
                    totalQuantity, // This variable is now correctly defined above
                    totalProfit,
                    profitAdmin: parseFloat(profitAdmin.toFixed(2)), // Ensure floating point is handled
                    productsList
                };
            });

            setOrders(ordersWithTotals);
        } catch (error) {
            Swal.fire("Error", error.response?.data?.message || "Something went wrong", "error");
        }

        setLoading(false);
    };    const generateMonths = (numMonths = 12) => {
        const months = [
            "janvier", "février", "mars", "avril", "mai", "juin",
            "juillet", "août", "septembre", "octobre", "novembre", "décembre"
        ];
        const currentDate = new Date();
        const result = ["Tout le temps"];
        for (let i = 0; i < numMonths; i++) {
            const d = new Date(currentDate.getFullYear(), currentDate.getMonth() - i, 1);
            result.push(`${months[d.getMonth()]} ${d.getFullYear()}`);
        }
        return result;
    };

    const monthsOptions = generateMonths(12);

    const filteredOrders = orders.filter(order => {
        const matchesID = order.OrderID.toString().includes(searchOrderID);

        if (selectedDate === 'Tout le temps') return matchesID;

        const orderDate = new Date(order.created_at);
        const [monthName, year] = selectedDate.split(' ');
        const monthIndex = [
            'janvier', 'février', 'mars', 'avril', 'mai', 'juin',
            'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'
        ].indexOf(monthName);

        const matchesDate = orderDate.getFullYear() === parseInt(year) && orderDate.getMonth() === monthIndex;

        return matchesID && matchesDate;
    });

    return (
        <AnimationRevealPage>
            <LightAdmin />
            <div className="w-100 p-3">
                <h1 className="text-dark display-4 mb-3">{t('Statistiques_des_commandes')}</h1>

                <div className="d-flex mb-3">
                    <input
                        type="text"
                        placeholder={t("Search by Order ID")}
                        value={searchOrderID}
                        onChange={(e) => setSearchOrderID(e.target.value)}
                        className="form-control me-2"
                    />

                    <select
                        value={selectedDate}
                        onChange={(e) => setSelectedDate(e.target.value)}
                        className="form-select"
                    >
                        {monthsOptions.map(month => (
                            <option key={month} value={month}>{month}</option>
                        ))}
                    </select>
                </div>

                <hr />

                <div className="table-responsive" style={{ maxHeight: '600px', overflowY: 'auto' }}>
                    <table className="table table-striped table-hover">
                        <thead className="table-primary" style={{ position: 'sticky', top: 0, zIndex: 2 }}>
                            <tr>
                                <th>{t('ID_de_commande')}</th>
                                <th>{t('Produits')}</th>
                                <th>{t('Quantity')}</th>
                                <th>{t('TotalProfit')}</th>
                                <th>{t('ProfitAdmin')}</th>
                            </tr>
                        </thead>
<tbody>
  {loading ? (
    <tr>
      <td colSpan="5" className="text-center">Loading...</td>
    </tr>
  ) : filteredOrders.length > 0 ? (
    <>
      {filteredOrders.map(order => (
        <tr key={order.OrderID}>
          <td>{order.OrderID}</td>
          <td>{order.productsList}</td>
          <td>{order.totalQuantity}</td>
          <td>{order.totalProfit.toFixed(2)}</td>
          <td>{order.profitAdmin.toFixed(2)}</td>
        </tr>
      ))}

      {/* Sticky Total Row */}
      <tr
        style={{
          fontWeight: 'bold',
          backgroundColor: '#f0f0f0',
          position: 'sticky',
          bottom: 0,
          zIndex: 1
        }}
      >
        <td colSpan={2} className="text-center">Total</td>
        <td>{filteredOrders.reduce((sum, order) => sum + order.totalQuantity, 0)}</td>
        <td>{filteredOrders.reduce((sum, order) => sum + order.totalProfit, 0).toFixed(2)}</td>
        <td>{filteredOrders.reduce((sum, order) => sum + order.profitAdmin, 0).toFixed(2)}</td>
      </tr>
    </>
  ) : (
    <tr>
      <td colSpan="5" className="text-center">No orders found.</td>
    </tr>
  )}
</tbody>
</table>
                </div>
            </div>
            <Footer />
        </AnimationRevealPage>
    );
};

export default OrderSalesAdmin;
